var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"title":"Patterns"}},[_c('div',{staticClass:"pattern-grid"},[_c('PatternSwatch',{attrs:{"action":"pick","random":true},on:{"pattern":_vm.props.addPattern}}),_vm._l((_vm.patterns),function(pattern){return _c('div',[_c('PatternSwatch',{attrs:{"action":"pick","pattern":pattern},on:{"pattern":_vm.props.addPattern}})],1)})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }